import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs';

import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { StockService } from '../../services/stock.service';
import { WarehouseService, Warehouse, ProductInStock } from '../../services/warehouse.service';
import { ProductCmpaService } from '../../services/product-cmpa.service';
import { ProductVntaService } from '../../services/product-vnta.service';
import { TranType } from '../../services/tran.service';
import { filter } from 'rxjs/operators';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Utils } from '../../util';
import { UnitService, UnitId } from '../../services/unit.service';
import { RowSorter } from '../../globals';

type Row = {classification: string, code: string, name: string, unitName: string, [wareId: string]: string}

@Component({
  selector: 'app-read-stock-pieces',
  templateUrl: './read-stock-pieces.component.html',
  styleUrls: ['./read-stock-pieces.component.css']
})
export class ReadStockPiecesComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  permission: any = {};
  
  unfilteredWarehouses: any[] = [];
  warehouses: any[] = [];
  unfilteredProducts: any[] = [];
  products: any[] = [];

  warehouse$: Observable<any>;

  filterStr: string = '';
  filterWarehouse: string = '';

  warehousesSub: Subscription;
  productSubs: Subscription[] = [];

  constructor(
    private stockService: StockService,
    private warehouseService: WarehouseService,
    private productCmpaService: ProductCmpaService,
    private productVntaService: ProductVntaService,
    private unitService: UnitService,
		private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, 'stockPiece');
        if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
        else this.allowed = true;
    });
    
    this.warehousesSub = this.warehouseService.getWarehouses().subscribe(warehouses => {
      this.unfilteredWarehouses = warehouses.map(warehouse => {
        warehouse.productsObj = warehouse.products.reduce( (acc, cur) => {
          acc[cur.ref.id] = cur.quantity;
          return acc;
        } , {});
        return warehouse;
      });
      this.unfilteredWarehouses.map((warehouse: Warehouse) => {
        warehouse.products.map(product => {
          if(!this.unfilteredProducts.some(({ref: {id}}) => product.ref.id == id)) this.unfilteredProducts.push({...product});
        });
      });
      if(!this.unfilteredProducts.length){
        this.applyFilter();
        toast('No hay productos en almacenes.', 4000);
      }
      
      let unitSub = this.unitService.getUnits().subscribe(units => {
        unitSub.unsubscribe();
        let unitsById: {[id: string]: UnitId} = units.reduce((acc, cur) => ({...acc, [cur.id]: cur}), {});
        let nameArrived = this.unfilteredProducts.map(a => false);
        this.unfilteredProducts.map((product, index) => {
          let isPrCmpa = product.ref.parent.id == 'prCmpa';
          let doc = productVntaService.getPrVnta(product.ref.id, product.ref.parent.id );
          this.productSubs[index] = doc.subscribe( ([product]) => {
            let characs = product.characs.reduce((acc, cur, index) => `${acc}${index ? ', ' : ''}${cur.name.charAt(0)} ${cur.value}${unitsById[cur.unitId.id] ? ` ${unitsById[cur.unitId.id].name}` : ''}`, '');
            this.productSubs[index].unsubscribe();
            this.unfilteredProducts[index].id = product.id;
            this.unfilteredProducts[index].class = `${product.data.name}`;
            this.unfilteredProducts[index].code = product.code;
            this.unfilteredProducts[index].name = `${product.name}${characs ? ' - ' + characs : ''}`;
            this.unfilteredProducts[index].unitName = isPrCmpa && product.unitRef ? (unitsById[product.unitRef.id] || {name: ''}).name : '';
            if(!product.active) this.unfilteredProducts[index].__deleted = true;
            nameArrived[index] = true;
            if(!nameArrived.includes(false)) this.readyToFilter = true;
            this.applyFilter();
          });
        });
      });

    });
  }

  ngOnInit() {
  }
  ngOnDestroy() {
    this.warehousesSub.unsubscribe();
  }

  readyToFilter: boolean = false;
  applyFilter(warehouse: string = this.filterWarehouse){
    if(!this.readyToFilter) return;
    this.filterWarehouse = warehouse;
    this.warehouses = this.unfilteredWarehouses.filter(({name}) => !this.filterWarehouse || this.filterWarehouse == name);
    this.products = this.unfilteredProducts.filter(({id, code, class: c, name, __deleted}) => !__deleted && this.warehouses.some(({productsObj: p}) => !!p[id]) && `${name};;;${code};;;${c}`.toLowerCase().includes(this.filterStr.toLowerCase()) );
    let sorterRows = [];
    for(let product of this.products){
      let {class: classification='', code='', name='', unitName='', ref:{id:prId=''}={}} = product;
      let row: Row = {classification, code, name, unitName};
      for(let ware of this.warehouses){
        let quantity = ware.productsObj[prId] || 0;
        if(quantity%1 != 0) quantity = +quantity.toFixed(2);
        row[ware.id] = quantity;
      }
      sorterRows.push(row);
    }
    this.sorter.originalRows = sorterRows;
  }

  sorter: RowSorter<Row> = new RowSorter([], 'classification', 'asc');
  

  get columns(){ return ['Clasificación', 'Código', 'Productos', 'Unidad de compra', ...this.warehouses.map(({name}) => name)] }
  onExcel(){
    let rows: any[] = [
      this.columns,
      ...this.sorter.rows.reduce((acc, {classification, code, name, unitName, id, ...row}) => [
        ...acc,
        [ classification, code, name, unitName, ...this.warehouses.map(ware => row[ware.id]) ],
      ], [])
    ];
    Utils.downloadExcel(rows, `Existencias_${Utils.today.replace(/-/g, '')}`);
  }

}